import React, { FC, useEffect, useState } from 'react';
import { useT } from 'hooks';
import * as S from './styled';
import { appStore } from '@store';
import { IHeightAnswer, IWeightAnswer } from 'modules/survey/helpers/unitsHelpers';
import scales from './img/scales.png';
import star from './img/star.png';
import heart from './img/heart.png';
import { Timer } from './components/timer';
import { Chart } from './components/chart';
import { Highlights } from './components/highlights';
import { useDates } from './helper/useDates';
import { getWeeksCountToReachTheGoal } from '@helpers';

export const PlanDescription: FC = props => {
	const { T } = useT();
	const { surveyStore } = appStore;
	const { weight, target_weight } = surveyStore.answers;
	const [deltaWeight, setDeltaWeight] = useState<number>();
	const [endDate, setEndDate] = useState<string>();

	const { unit: weightUnit, value: currentWeight }: IWeightAnswer = weight
		? JSON.parse(weight.join())
		: {};
	const { value: targetWeight }: IWeightAnswer = target_weight
		? JSON.parse(target_weight.join())
		: {};

	useEffect(() => {
		setDeltaWeight(Number(currentWeight) - Number(targetWeight));
		const end = useDates(getWeeksCountToReachTheGoal(Number(currentWeight), Number(targetWeight)));
		setEndDate(end[1]);
	}, []);

	return (
		<S.Container>
			<S.Description>
				<ul>
					<li>
						<img src={scales} alt='scales' />
						<p>
							<span>
								Lose {deltaWeight} {weightUnit}
							</span>{' '}
							by {endDate} and feel great
						</p>
					</li>
					<li>
						<img src={star} alt='star' />
						<p>Build healthy habits to keep the weight off after hitting your goal</p>
					</li>
					<li>
						<img src={heart} alt='heart' />
						<p>Get healthy with the foods you love</p>
					</li>
				</ul>
			</S.Description>
			<S.Disclaimer>
				<h4>Your personalized plan is reserved</h4>
				<p>We&apos;ve reserved your personalized plan for 15 minutes. Don&apos;t miss out!</p>
				<h3>
					TIME REMAINING:&nbsp;
					<Timer />
				</h3>
			</S.Disclaimer>
			<Chart
				currentWeight={currentWeight}
				targetWeight={targetWeight}
				deltaWeight={deltaWeight}
				weightUnit={weightUnit}
				endDate={endDate}
			/>
			<Highlights />
		</S.Container>
	);
};
